import InputBase from "./InputBase";

const NumberInput = ({
  maxLength = 10,
  onChange,
  name,
  required,
  ...props
}) => {
  const handleChange = (e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");

    // Enforce max length
    if (value.length <= maxLength) {
      onChange?.({
        ...e,
        target: {
          ...e.target,
          name,
          value,
        },
      });
    }
  };

  return (
    <InputBase
      {...props}
      type="tel"
      label={name}
      required={required}
      inputMode="numeric"
      onChange={handleChange}
    />
  );
};

export default NumberInput;
